export default class {
    static projectName = "Rajmith";
    static userData = "USER_DATA";
    static themeColor = '#fffa76';
    static textColor = "#000000";
    static emailRjx = /\S+@\S+\.\S+/;
    // static API_URL = "http://192.168.1.148:8088";
    static API_URL = "https://api.rajmith.com";
    static jobPositions = [
        { title: "Software Developer", value: "Software Developer" },
        { title: "Quality & Testing", value: "Quality & Testing" },
        { title: "Sales & Business", value: "Sales & Business" },
        { title: "UI/UX Design", value: "UI/UX Design" },
        { title: "Human Resource", value: "Human Resource" },
        { title: "SEO/SMO/Digital marketing", value: "SEO/SMO/Digital marketing" },
        { title: "Telesales / Marketing", value: "Telesales / Marketing" },
        { title: "Security", value: "Security" },
        { title: "Data Analytics", value: "Data Analytics" },
        { title: "Finance / Account", value: "Finance / Account" },
        { title: "Content Writer", value: "Content Writer" },
        { title: "Graphics / Print Media", value: "Graphics / Print Media" }
    ];
}